import { removeLocalStorage, setLocalStorage } from '.'

import { cancelOrder as cancelOrderOCC } from '@vista/omnichannel-components-domain'

export function cancelOrder(orderId: string):void {
    setLocalStorage('cancelled-order-id', orderId)
    removeLocalStorage('continue-order-id')
    cancelOrderOCC()
}
